import styled from '@emotion/styled';

export const NotificationItemWrapper = styled('div')`
  overflow: hidden;
  opacity: ${({ isExiting }) => (isExiting ? 0 : 1)};
  transform: ${({ isExiting }) => (isExiting ? 'translateX(12px)' : 'translateX(0)')};
  max-height: ${({ isExiting }) => (isExiting ? 0 : 140)}px;
  pointer-events: ${({ isExiting }) => (isExiting ? 'none' : 'auto')};
  transition: opacity 220ms ease, transform 220ms ease, max-height 220ms ease;
`;

export const NotificationIconCircle = styled('div')`
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const NotificationMessage = styled('p')`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;
